import { render, staticRenderFns } from "./LoraParsers.vue?vue&type=template&id=22b2862c&scoped=true&"
import script from "./LoraParsers.vue?vue&type=script&lang=ts&"
export * from "./LoraParsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2862c",
  null
  
)

export default component.exports